<template>
    <div class="text-top">
    <v-dialog
      v-model="show"
      persistent
      width="500"
    >
      <v-card tile>
        <v-card-title>{{title}}</v-card-title>
        <v-form ref="form" v-model="isValid" class="pa-5">
            <v-text-field
                filled
                label="Email or Mobile number"
                required
                autocomplete="off"
                v-bind:rules="validation.username"
                v-model="serverData.username"
            >
            </v-text-field>
            <v-text-field
                filled
                label="Password"
                required
                v-model="serverData.password"
                v-bind:append-icon="
                    shouldShowPassword ? 'mdi-eye-off' : 'mdi-eye'
                  "
                v-bind:type="shouldShowPassword ? 'text' : 'password'"
                  v-on:click:append="
                    () => (shouldShowPassword = !shouldShowPassword)
                  "
            >
            </v-text-field>
            <v-text-field
                filled
                label="Confirm password"
                required
                v-model="serverData.confirm_password"
                v-bind:append-icon="
                    shouldShowConfirmPassword ? 'mdi-eye-off' : 'mdi-eye'
                  "
                v-bind:type="shouldShowConfirmPassword ? 'text' : 'password'"
                  v-on:click:append="
                    () => (shouldShowConfirmPassword = !shouldShowConfirmPassword)
                  "
            >
            </v-text-field>
            <v-row class="mr-1">
              <v-spacer/>
              <v-btn
                color="primary"
                @click.stop="cancelDialog"
                class="mr-2"
              >
                  Close
              </v-btn>
              <v-btn
                color="primary"
                @click.stop="addAdmin"
                :loading = "loading"
                v-bind:disabled="!isValid"
                v-if="admin == null"
              >
                  Add Admin
              </v-btn>
              <v-btn
                  color="primary"
                  v-else
                  v-bind:disabled="!isValid"
                  @click.stop="updateAdmin"
                  :loading = "loading"
              >
                  Update
              </v-btn>
            </v-row>
        </v-form>
    </v-card>
    </v-dialog>
    </div>
</template>
<script>
import snackbar from '@/utils/snackbar'
import superAdminApi from '@/api/superAdminApi'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    title: {
      type: String,
      default: 'Add admin',
      required: false
    },
    admin: {
      type: Object,
      default: null
    }
  },
  mounted () {
    this.$log.info('addedit admin dialog', [this.admin])
    if (this.admin !== null) {
      if (this.admin.id !== null) {
        this.serverData.id = this.admin.id
      }

      if (this.admin.email !== null) {
        this.serverData.username = this.admin.email
      } else if (this.admin.mobile_number !== null) {
        this.serverData.username = this.admin.mobile_number
      }
    }
  },
  data () {
    return {
      loading: false,
      isValid: false,
      validation: {
        username: [(v) => !!v || 'Username is required'],
        password: [(v) => !!v || 'Password is required'],
        confirm_password: [(v) => !!v || 'Confirm Password is required']
      },
      shouldShowPassword: false,
      shouldShowConfirmPassword: false,
      serverData: {
        id: null,
        username: null,
        password: null,
        confirm_password: null
      }
    }
  },
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    }
  },
  methods: {
    async updateAdmin () {
      if (this.serverData.password != null && this.serverData.confirm_password !== null && this.serverData.password !== this.serverData.confirm_password) {
        snackbar.show('Password mismatch. Please try again', 'error')
        return
      }
      try {
        this.loading = true
        const response = await superAdminApi.updateAdmin(this.serverData)
        if (response.data !== undefined) {
          if (response.data === 'success') {
            snackbar.show('Admin updated successfully', 'success')
            this.$emit('refresh')
            this.cancelDialog()
          }
        }
      } finally {
        this.loading = false
      }
    },
    async addAdmin () {
      if (this.serverData.password !== this.serverData.confirm_password) {
        snackbar.show('Password mismatch. Please try again', 'error')
        return
      }
      try {
        this.loading = true
        const response = await superAdminApi.addAdmin(this.serverData)
        if (response.data !== undefined) {
          if (response.data === 'success') {
            snackbar.show('Admin added successfully', 'success')
            this.$emit('refresh')
            this.cancelDialog()
          }
        }
      } finally {
        this.loading = false
      }
    },
    cancelDialog () {
      if (this.admin == null) {
        this.$refs.form.reset()
      }

      this.$emit('close')
    },
    confirmDelete () {
      this.$emit('deleting', this.data)
      this.$emit('close')
    }
  }
}
</script>
